module.exports = __webpack_public_path__ + "static/media/298336.3316ace0.png";